import { PackageVip } from '@models/client'

export const getPackageVipName = (packageVip: PackageVip): string =>
  `Pakiet VIP ${packageVip.type === 'standard' ? 'standardowy' : 'zimowy'}`
